import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Button from 'components/common/Button';

const styles = theme => ({
  root: {
    width: 190,
    [theme.breakpoints.down('sm')]: {
      margin: '0 auto',
    },
  },
});

const DeleteMenu = ({
  text,
  submitButtonText,
  submitButtonColor,
  cancelButtonText,
  onCancel,
  onSubmit,
  classes,
}) => (
  <div className={classes.root}>
    {text &&
      <Grid
        container
        justify="center"
        wrap="nowrap"
        spacing={16}
      >
        <Grid
          item
          xs={12}
        >
          <Typography
            variant="caption"
            color="secondary"
            align="center"
            gutterBottom
          >
            {text}
          </Typography>
        </Grid>
      </Grid>
    }
    <Grid
      container
      justify="center"
      wrap="nowrap"
      spacing={16}
    >
      <Grid
        item
      >
        <Button
          variant="raised"
          onClick={onCancel}
        >
          {cancelButtonText}
        </Button>
      </Grid>
      <Grid
        item
      >
        <Button
          variant="raised"
          onClick={onSubmit}
          color={submitButtonColor === 'primary' ? 'primary' : 'warning'}
        >
          {submitButtonText}
        </Button>
      </Grid>
    </Grid>
  </div>
);

DeleteMenu.propTypes = {
  text: PropTypes.string,
  submitButtonColor: PropTypes.string,
  submitButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

DeleteMenu.defaultProps = {
  text: null,
  submitButtonText: 'Delete',
  cancelButtonText: 'Cancel',
  onCancel: () => {},
  onSubmit: () => {},
  submitButtonColor: 'warning',
};

export default withStyles(styles)(DeleteMenu);



// WEBPACK FOOTER //
// ./src/components/common/DeleteMenu.js